{
    "coordinates": [
        34.063772000377824,
        -118.35631399475255
    ],
    "tooltip": "La Brea",
    "title": "La Brea Tar Pits",
    "country": "United States",
    "period": "Quaternary",
    "alt": "TODO"
}
